import { useAuthentication } from '@zenbusiness/application-commons-authentication';
import Heading from '@zenbusiness/zui/Heading';

import Template from '#client/components/Template';

const Logout = () => {
  const { logout } = useAuthentication();
  logout();

  return (
    <Template loading>
      <div>
        <Heading
          align="center"
          gutterBottom
          size="2xl"
          weight="bold"
        >
          Logging out of your ZenBusiness account...
        </Heading>
      </div>
    </Template>
  );
};

export default Logout;
